import { Component } from '@angular/core';
import { CobaltButtonComponent } from '@cae/cobalt-angular/components/button';
import { CobaltModalActionsDirective, CobaltModalContentDirective, CobaltModalTitleDirective } from '@cae/cobalt-angular/components/modal';

@Component({
  selector: 'app-network-connection-dialog',
  templateUrl: './network-connection-dialog.component.html',
  styleUrls: ['./network-connection-dialog.component.less'],
  standalone: true,
  imports: [
    CobaltButtonComponent,
    CobaltModalActionsDirective,
    CobaltModalContentDirective,
    CobaltModalTitleDirective,
  ]
})
export class NetworkConnectionDialogComponent {
  isOnLine: boolean = true;

  public tryAgainClick(): void {
    window.location.reload();
  }
}
